const milestoneSets = {
  math: [
    { percent: 25, symbol: '✏️', label: 'Pencil milestone' },
    { percent: 50, symbol: '∑', label: 'Equation milestone' },
    { percent: 75, symbol: '✓', label: 'Solution milestone' },
    { percent: 100, symbol: '🏆', label: 'Math mastery milestone' }
  ],
  rocks: [
    { percent: 25, symbol: '•', label: 'Pebble milestone' },
    { percent: 50, symbol: '🪨', label: 'Rock milestone' },
    { percent: 75, symbol: '⛰️', label: 'Mountain milestone' },
    { percent: 100, symbol: '💎', label: 'Geology mastery milestone' }
  ],
  physics: [
    { percent: 25, symbol: '→', label: 'Motion milestone' },
    { percent: 50, symbol: '⚙️', label: 'Mechanics milestone' },
    { percent: 75, symbol: '💡', label: 'Discovery milestone' },
    { percent: 100, symbol: '🚀', label: 'Physics mastery milestone' }
  ],
  neutral: [
    { percent: 25, symbol: '☆', label: 'First milestone' },
    { percent: 50, symbol: '★', label: 'Second milestone' },
    { percent: 75, symbol: '✦', label: 'Third milestone' },
    { percent: 100, symbol: '🏅', label: 'Lesson mastery milestone' }
  ]
};

const lessonMilestoneKeys = {
  'linear-equations': 'math',
  'graphing-lines': 'math',
  'rock-cycle': 'rocks',
  'newtons-first-law': 'physics'
};

export function getLessonMilestones(lesson) {
  const lessonKey = lessonMilestoneKeys[lesson?.id];

  if (lessonKey) {
    return milestoneSets[lessonKey];
  }

  if (lesson?.subject?.toLowerCase() === 'math') {
    return milestoneSets.math;
  }

  return milestoneSets.neutral;
}